export const navBarData = [
  { to: "hero", text: "Home" },
  { to: "works", text: "Works" },
  { to: "about", text: "About Me" },
  { to: "contact", text: "Contact Me" },
];
